<template>
  <div class="flex gap-8 items-center small neutral-gray">
    Showing

    <w-dropdown-menu>
      <template #trigger>
        <div class="page-size__dropdown flex gap-12 items-center">
          <span class="neutral-black">{{ modelValue }}</span>
          <iconify-icon icon="fa:caret-down" class="neutral-gray smaller" />
        </div>
      </template>
      <template #content>
        <div class="px-2">
          <w-dropdown-menu-item v-for="(option, index) in options" :key="index" class="page-size__option" @click="setPageSize(option)">
            {{ option }}
          </w-dropdown-menu-item>
        </div>
      </template>
    </w-dropdown-menu>

    Entries
  </div>
</template>

<script>
  export default {
    name: 'WTablePageSize',
    emits: ['update:modelValue', 'change'],
    props: {
      options: {
        Array,
        default: [5, 10, 20, 50],
      },
      modelValue: {
        Number,
        required: true,
      },
    },

    methods: {
      setPageSize(option) {
        this.$emit('update:modelValue', option);
        this.$emit('change', option);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';
  .page-size__dropdown {
    border: 1px solid $input-border;
    padding: 0.4rem 0.375rem;
    border-radius: 0.5rem;
  }

  .page-size__option {
    min-width: 64px;
  }
</style>
